export const it = {
  dialogComponent: {
    close: "Chiudi",
    confirm: "Conferma",
    exit: "Esci",
    generateTaxCode: "Genera codice fiscale",
    calculateTaxCode: "Calcola codice fiscale",
    backWarningTitle: "Attenzione",
    backWarningText:
      "Vuoi uscire dal sito ? Le modifiche effettuate potrebbero non essere salvate.",
  },
};
